import { IAreaVariationCard, nameProps } from '../../types';
import { makeVirgula } from '../factorys';

// ufs.join(', ) => retorna valores separados por virgulas e espaços
const performFerderalUnion = (ufs: string[]): string => ufs.join(', ');

// retorna o valor quando o card é referente a posição
const performPositionValue = (value: number, len: number): string => {
  switch (Math.sign(value)) {
    case 1:
      if (len > 1) {
        return `Ganharam ${value} posições`;
      }
      return `Ganhou ${value} posições`;
    case -1:
      if (len > 1) {
        return `Perderam ${Math.abs(value)} posições`;
      }
      return `Perdeu ${Math.abs(value)} posições`;
    default:
      return 'Se manteve estável';
  }
};

//retorna o valor quando o card é referente ao indicador
const performIndicatorValue = (value: number): string => {
  switch (Math.sign(value)) {
    case 1:
      return `Cresceu ${makeVirgula(value)}`;
    case -1:
      return `Caiu ${makeVirgula(Math.abs(value))}`;
    default:
      return 'Se manteve estável';
  }
};

// constrói o objeto que será plotado na tela
export function performCard(data: IAreaVariationCard, name: nameProps) {
  if (!data) return;
  return Object.entries(data).reduce((acc, [key, value]) => {
    if (name === 'posicao') {
      switch (key) {
        case 'ano':
          const bestYearUfs = [...value.melhor.UF];
          const bestYearValue = value.melhor.valor;
          acc.ano.melhor.UF = performFerderalUnion(bestYearUfs);
          acc.ano.melhor.valor = performPositionValue(bestYearValue, bestYearUfs.length);

          const worstYearUfs = [...value.pior.UF];
          const worstYearValue = value.pior.valor;
          acc.ano.pior.UF = performFerderalUnion(worstYearUfs);
          acc.ano.pior.valor = performPositionValue(worstYearValue, worstYearUfs.length);
          break;
        case 'decada':
          const bestDecadeUfs = [...value.melhor.UF];
          const bestDecadeValue = value.melhor.valor;
          acc.decada.melhor.UF = performFerderalUnion(bestDecadeUfs);
          acc.decada.melhor.valor = performPositionValue(bestDecadeValue, bestDecadeUfs.length);

          const worstDecadeUfs = [...value.pior.UF];
          const worstDecadeValue = value.pior.valor;
          acc.decada.pior.UF = performFerderalUnion(worstDecadeUfs);
          acc.decada.pior.valor = performPositionValue(worstDecadeValue, worstDecadeUfs.length);
          break;
        default:
          break;
      }
    }

    if (name === 'indicador') {
      switch (key) {
        case 'ano':
          acc.ano.melhor.UF = performFerderalUnion(value.melhor.UF);
          acc.ano.melhor.valor = performIndicatorValue(value.melhor.valor);

          acc.ano.pior.UF = performFerderalUnion(value.pior.UF);
          acc.ano.pior.valor = performIndicatorValue(value.pior.valor);
          break;
          case 'decada':
          acc.decada.melhor.UF = performFerderalUnion(value.melhor.UF);
          acc.decada.melhor.valor = performIndicatorValue(value.melhor.valor);

          acc.decada.pior.UF = performFerderalUnion(value.pior.UF);
          acc.decada.pior.valor = performIndicatorValue(value.pior.valor);
          break;
        default:
          break;
      }
    }
    return acc;
  }, {
    ano: {
      melhor: { UF: '', valor: '' },
      pior: { UF: '', valor: '' }
    },
    decada: {
      melhor: { UF: '', valor: '' },
      pior: { UF: '', valor: '' }
    }
  });
}
